<template>
  <div class="icon" :style="style">
    <svg width="80" height="80" viewBox="0 0 85 85">
      <circle cx="42" cy="42" r="38" :stroke="color" stroke-width="3" fill="white" />

      <!-- Batériová ikona -->
      <g transform="translate(19, 16) scale(0.05)">
        <path d="M792 288H128c-52.8 0-96 43.2-96 96v256c0 52.8 43.2 96 96 96h664c52.8 0 96-43.2 96-96V384c0-52.8-43.2-96-96-96z m40 352c0 22-18 40-40 40H128c-22 0-40-18-40-40V384c0-22 18-40 40-40h664c22 0 40 18 40 40v256z m96-230.8v205.6c32 0 64-55.4 64-102.8s-32-102.8-64-102.8z" fill="black"/>
        <path d="M768 384H152c-13.2 0-24 10.8-24 24v208c0 13.2 10.8 24 24 24h616c13.2 0 24-10.8 24-24V408c0-13.2-10.8-24-24-24z" fill="#27ae60"/>
      </g>
    </svg>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  x: Number,
  y: Number,
  label: String,
  color: { type: String, default: '#27ae60' }
})

const style = computed(() => ({
  position: 'absolute',
  left: `${props.x - 30}px`,
  top: `${props.y - 30}px`
}))
</script>

<style scoped>
.icon {
  pointer-events: none;
}
</style>
